define('klaviyo.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('klaviyo', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<section class=\"klaviyo-info-card\"><div class=\"klaviyo-form-Xk2HkN\"></div><div class=\"klaviyo-form-TxqFua\"></div></section>";
},"useData":true}, 'extensions/MHI/Klaviyo/1.0.0/', 'extensions/MHI/Klaviyo/1.0.0/', Handlebars);
});